export default {
  close: 'Close',
  learnMore: 'Learn more',
  new: 'New',
  continue: {
    capitalize: 'Continue',
    uppercase: 'CONTINUE',
  },
  signUp: 'Sign up',
  signUpNow: 'Sign up now',
  cancel: 'Cancel',
  logIn: 'Log in',
  free: 'Free',
  logOut: 'Log out',
  search: 'Search',
  visitDetails: 'Visit details',
  select: 'Select',
  ok: 'OK',
  save: 'Save',
  saveAndContinue: 'Save and continue',
  skip: 'Skip',
  skipForNow: 'Skip for now',
  done: 'Done',
  or: 'Or',
  edit: 'Edit',
  update: 'Update',
  change: 'Change',
  required: 'Required',
  optional: 'Optional',
  currentLocation: 'Current location',
  no: 'No',
  yes: 'Yes',
  tryAgain: {
    capitalize: 'Try again',
    uppercase: 'TRY AGAIN',
  },
  finish: 'Finish',
  today: {
    capitalize: 'Today',
    lowercase: 'today',
    uppercase: 'TODAY',
  },
  tomorrow: {
    capitalize: 'Tomorrow',
    lowercase: 'tomorrow',
    uppercase: 'TOMORROW',
  },
  yesterday: {
    capitalize: 'Yesterday',
    lowercase: 'yesterday',
    uppercase: 'YESTERDAY',
  },
  monday: {
    capitalize: 'Monday',
    lowercase: 'monday',
  },
  tuesday: {
    capitalize: 'Tuesday',
    lowercase: 'tuesday',
  },
  wednesday: {
    capitalize: 'Wednesday',
    lowercase: 'wednesday',
  },
  thursday: {
    capitalize: 'Thursday',
    lowercase: 'thursday',
  },
  friday: {
    capitalize: 'Friday',
    lowercase: 'friday',
  },
  saturday: {
    capitalize: 'Saturday',
    lowercase: 'saturday',
  },
  sunday: {
    capitalize: 'Sunday',
    lowercase: 'sunday',
  },
  each: {
    month: 'per month',
    visit: 'per visit',
  },
  subscribe: 'Subscribe',
  goToAccount: 'Go to my account',
  form: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email address',
    dateOfBirth: 'Date of birth',
    birthSex: 'Birth sex',
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  errors: {
    generic: {
      title: 'Something went wrong',
      description: 'Please reload the page or try again later.',
    },
  },
  '911':
    'For medical emergencies, call 911 (or your local emergency number) or go to the nearest emergency room',
  auth: {
    signup: {
      title: 'Finish creating your account',
      subtitle: 'Fill in the following details to finish creating your Solv account for {{phone}}',
    },
    phoneForm: {
      title: "What's your number?",
      redirectTitle: 'To continue, enter your mobile number',
      subtitle: "We'll text a code to verify your phone.",
      fieldTitle: 'Mobile phone number',
      newToSolv: "Looks like you're new to Solv, welcome!",
      lasteNameField: "Patient's last name",
      cta: 'Continue',
      feedbackMode: {
        title: 'Thanks for your feedback!',
        subtitle:
          'Before we can publish your review, you need to sign up or log in with your mobile number.',
      },
    },
    otpForm: {
      title: "What's your code?",
      subtitle: 'Enter the code sent to your phone.',
      subtitleWithPhone: 'Enter the code sent to {{phone}}.',
      enterCode: 'Enter 4-digit Solv code',
      problemReceivingCode: 'Problems receiving the code?',
      resend: 'Didn’t receive your code?  Get another code <0>by text</0> or <1>by phone call</1>.',
      resendOrSkip:
        'Didn’t receive your code? Resend <0>by text</0>, <1>by phone call</1>, or <2>continue without logging in</2>.',
      continueAndAgree: 'Agree and continue',
      verifyAndLogin: 'Verify and log In',
      accountLocked:
        "To protect your privacy, we've locked your account. Please tray again in 2 minutes.",
      otpError: 'Please double check the code and try again.',
      keepMeLoggedIn: 'Keep me logged in',
      persistedLoginWarning:
        'If this is a shared or public device, we do not recommend using this option.',
      wrongNumber: 'Wrong number?',
    },
    loginAccountVerification: {
      title: 'To continue, please confirm the details from a previous booking.',
      subtitle: "This extra security step helps us check that it's really you.",
      chooseHowToIdentify: 'Choose how to verify your account',
      error:
        "This doesn't match our records. Try again, or contact support below for further assistance.",
      help: 'Need help?',
      contact: 'Contact support',
    },
    clinicDisclaimer:
      '<0>{{clinicName}}</0> uses <1>Solv</1> to make it easy for you to manage your visits and insurance.',
    errors: {
      generic: "Oops. That didn't work. Check the code and try again.",
      accountFrozen:
        'We’ve temporarily locked your account. You must wait {{count}} minute before trying again.',
      accountFrozen_plural:
        'We’ve temporarily locked your account. You must wait {{count}} minutes before trying again.',
      havingTrouble: 'Having trouble? Contact the Solv support team at <0>info@solvhealth.com</0>',
      phoneMismatch:
        'The number you provided does not match what we have on record. To update your number, cancel this visit and re-book with your updated number.',
      phoneMismatchTitle: 'Mismatched mobile phone number',
      cancelYourVisit: 'Cancel your visit',
      tooManyFailedAttempts: 'Too many failed attempts',
    },
  },
  legal: {
    agreeTosAndPp:
      'By clicking <strong>$t(auth.otpForm.continueAndAgree)</strong> I agree to Solv Health’s <0>Terms of Service</0>, and <1>Privacy Policy</1>.',
    agreeCreateAccount:
      'By clicking <strong>$t(auth.otpForm.continueAndAgree)</strong>, I agree to create an account and agree to Solv Health’s <0>Terms of Service</0> and <1>Privacy Policy</1>.',
  },
  legalLinks: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
  },
  bookingTimeSelector: {
    showMore: 'Show more',
    viewAllAvailability: 'View all availability',
    noTimesAvailable: 'No times available',
    slotSelectorStates: {
      onlineBookingOnlyTodayOrTomorrow:
        'Online booking is only available for same day and next day. Please check back tomorrow.',
      fewerTimes: 'see fewer times',
      moreTimes: 'see more times',
      moreDates: 'MORE DATES',
      clinicClosed: {
        clinicClosed: 'Clinic Closed',
        thisClinicIsClosedTomorrow: 'This clinic is closed tomorrow',
        thisClinicIsClosedToday: 'This clinic is closed today',
        thisClinicWasClosedYesterday: 'This clinic was closed yesterday',
        thisClinicIsClosedXDay: 'This clinic is closed {{day}}',
        youCanStillBookXDay: 'You can still book a visit for {{day}}',
        youCanStillBookTomorrow: 'You can still book a visit for tomorrow',
        youCanStillBookToday: 'You can still book a visit for today',
        findNextAvailableVisit: 'Find Next Available Visit',
      },
      noSlotsLeft: {
        youCanStillWalkIn: 'You can still walk in to the clinic.',
        noAvailabilityToday: 'No availability today',
        noAvailabilityTomorrow: 'No availability tomorrow',
        noAvailabilityXDay: 'No availability {{day}}',
        noVisitTimesLeft: 'No visit times left',
        allOnlineSlotsFull: 'All online booking slots are full.',
        bookAheadVisitsFullyBookedTomorrow: 'Book ahead visits are fully booked tomorrow.',
        bookAheadVisitsFullyBookedToday: 'Book ahead visits are fully booked today.',
        bookAheadVisitsFullyBookedXDay: 'Book ahead visits are fully booked {{day}}.',
        stillAcceptingWalkIns:
          'This location is accepting walk-ins - get in line to save your spot!',
      },
    },
  },
  userInfo: {
    patientSex: {
      capitalize: 'Patient sex',
      capitalCase: 'Patient Sex',
    },
    sexMale: 'Male',
    sexFemale: 'Female',
    sexOther: 'Other',
    birthDateMonth: 'Birth date: Month',
  },
  day: 'Day',
  year: 'Year',
  back: 'Back',
  haveReadUnderstandTOSPP:
    "I have read, understand and agree to Solv Health's <0>Terms of Service</0> and <1>Privacy Policy</1>.",
  agreeToReceiveElectronicCommunications:
    "I agree to receive text messages in accordance to Solv Health's <0>Terms of Service</0>.",
  loading: 'Loading',
  dtFormat: {
    fallback: {
      numericMonthDayYear: 'MM/DD/YYYY',
      numericMonthDayYearTimeOfDay: 'MM/DD/YYYY h:mm a',
      unambiguousNumericMonthDayYear: 'YYYY-MM-DD',
      unambiguousNumericMonthDayYearTimeOfDay: 'YYYY-MM-DD h:mm a',
    },
    dayOfWeekDateMonth: 'dddd, MMMM D',
    dayOfWeekDateMonth_example1: 'Tuesday, March 5',
    dayOfWeekDateMonth_example2: 'Tomorrow, January 15',
    lastDayOfWeek: '[Last] dddd',
    lastDayOfWeek_example1: '[Last] Thursday',
    stdHourAndPeriod: 'h:mm a',
    monthAndDate: 'MMMM Do',
    monthAndDate_example1: 'April 5th',
    monthAndDateAtTimePeriod: 'MMMM Do [at] h:mm a',
    monthAndDateAtTimePeriod_example1: 'August 3rd [at] 5:30 PM',
    selectMonthDayAtTime: '[Select] MMMM Do [at] h:mm a',
    selectMonthDayAtTime_example1: '[Select] February 13th [at] 11:25 AM',
    dayOfWeekAndMonthAndDateAtTimePeriod: 'dddd, MMMM Do [at] h:mm a',
    checkedInDayOfWeekAndMonthAndDateAtTimePeriod: '[Checked in] dddd, MMMM Do [at] h:mm a',
    yesterdayAndMonthAndDateAtTimePeriod: '[Yesterday], MMMM Do [at] h:mm a',
    todayAndMonthAndDateAtTimePeriod: '[Today], MMMM Do [at] h:mm a',
    checkedInYesterdayAndMonthAndDateAtTimePeriod: '[Checked in Yesterday], MMMM Do [at] h:mm a',
    checkedInTodayAndMonthAndDateAtTimePeriod: '[Checked in Today], MMMM Do [at] h:mm a',
  },
  skipUploadingPhotos: 'Skip uploading photos',
  seeLess: 'See less',
  seeMore: 'See more',
  at: 'at',
  checkedIn: 'checked in',
  addNewFamilyMember: 'Add new family member',
  whosVisiting: "Who's Visiting?",
  whoIsBeingSeen: 'Who is being seen?',
  addressSameAsAccount: 'Patient’s address is the same as account',
  nav: {
    tabs: {
      getCare: 'Get care',
      appointments: 'Appointments',
      visits: 'Visits',
      chat: 'Chat',
      insurance: 'Insurance',
      profile: 'Profile',
    },
  },
  exit: 'Exit',
  submit: 'Submit',
};
